import React, { useState } from 'react';
import { useProjectModel } from '../../../model.js';
import { generateDashboardExternalPage } from './generate.js';
import { useGenerationTask } from '../hooks/use-generation-task.js';
import { UrlStep, NameStep } from './steps.js';
import {
  CompleteGeneration,
  CompleteGenerationMessage,
} from '../CompleteGeneration.js';

export const useGenerateDashboardExternalPage = () => {
  const { model } = useProjectModel();

  const [url, setUrl] = useState<string>();
  const [name, setName] = useState<string>();

  const questionsAnswered = url && name;

  const generationTask = useGenerationTask(async () => {
    if (!questionsAnswered) {
      return;
    }

    return generateDashboardExternalPage(model.projectFolder, name, url);
  }, [questionsAnswered]);

  return [
    <UrlStep onSubmit={setUrl} />,
    <NameStep name={name} onSubmit={setName} />,
    <CompleteGeneration
      generationTask={generationTask}
      extensionType={'dashboard external page'}
      successMessage={CompleteGenerationMessage.SuccessMessage({
        learnMoreUrl: 'https://dev.wix.com/docs/wix-cli',
      })}
      route={name}
    />,
  ];
};
